




























































import Vue, { PropType } from 'vue'
import CreateDialog from '@/components/CreateDialog.vue'
import appStepper from '@/components/Stepper.vue'
import { CustomVueForm } from '@/utils/interfaces'
import {
  CreateTariffDTO,
  Tariff,
} from '@/utils/interfaces/remittance.interface'
import {
  createMultipleTariff,
  createTariff,
} from '@/api/Remittances/remittances.api'
import TariffInfo from './TariffInfo.vue'
import MultipleTariffSettings from './MultipleTariffSettings.vue'
import TariffSettings from './TariffSettings.vue'
import Confirmation from './Confirmation.vue'

export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
    appStepper,
    TariffInfo,
    MultipleTariffSettings,
    TariffSettings,
    Confirmation,
  },
  props: {
    value: Boolean,
    item: Object as PropType<null | Tariff>,
    type: String as PropType<'CLIENT' | 'AGENCY'>,
    multiple: Boolean,
  },
  data() {
    return {
      stepperModel: 1,
      steps: [
        ['tariff-info', 'TariffInfo'],
        ['tariff-settings', 'MultipleTariffSettings'],
        ['confirmation', 'Confirmation'],
      ],
      crud: {} as CreateTariffDTO,
      loading: false,
    }
  },
  methods: {
    async onSuccess(): Promise<void> {
      if (this.stepperModel < this.steps.length) {
        if (!this.currentComponent?.validate()) return
        this.crud = Object.assign(this.crud, this.currentComponent?.getData())
        this.crud.type = this.type
        this.$store.commit(
          'remittance/data',
          JSON.parse(JSON.stringify(this.crud)),
        )
        this.stepperModel++
      } else {
        try {
          let data: Tariff
          this.loading = true
          if (this.multiple) {
            data = (
              await createMultipleTariff({
                ...this.crud,
                agency: this.crud.agency || this.$store.getters.profile.agency,
                to_agencies:
                  this.type === 'CLIENT' ? undefined : this.crud.to_agencies,
              })
            ).data
          } else {
            data = (
              await createTariff({
                ...this.crud,
                agency: this.crud.agency || this.$store.getters.profile.agency,
              })
            ).data
          }
          this.$emit('new-item', data)
          this.$emit('input', false)
        } finally {
          this.loading = false
        }
      }
    },
    onReject() {
      if (this.stepperModel > 1) {
        this.stepperModel--
      }
    },
    setData(value: Tariff | null) {
      const steps = this.$refs.steps as CustomVueForm[]
      if (steps) {
        for (const step of steps) {
          step.setData?.(value)
        }
      }
    },
  },
  computed: {
    currentComponent(): undefined | CustomVueForm {
      const steps = this.$refs.steps as CustomVueForm[]
      const step = steps.find(
        step =>
          (step.name || step.$attrs.name) ===
          this.steps[this.stepperModel - 1][1],
      )
      return step
    },
  },
  watch: {
    item(value: Tariff) {
      if (value) {
        this.crud = value
        this.setData(value)
      } else {
        this.crud = {} as CreateTariffDTO
        this.setData(null)
      }
    },
    value(value: boolean) {
      if (!value) {
        this.stepperModel = 1
      } else if (this.item) {
        this.crud = this.item
        this.setData(this.item)
      }
    },
    async multiple(value: boolean) {
      if (value) {
        this.steps = [
          ['tariff-info', 'TariffInfo'],
          ['tariff-settings', 'MultipleTariffSettings'],
          ['confirmation', 'Confirmation'],
        ]
      } else {
        this.steps = [
          ['tariff-info', 'TariffInfo'],
          ['tariff-settings', 'TariffSettings'],
          ['confirmation', 'Confirmation'],
        ]
      }
      this.stepperModel = 1
      await this.$nextTick()
      if (this.item) {
        this.crud = this.item
        this.setData(this.item)
      } else {
        this.crud = {} as CreateTariffDTO
        this.setData(null)
      }
    },
  },
})
